import { Col, Row } from 'antd';
import Logo from 'components/Logo';
import { SIGN_IN_PATH } from 'constant/authenticationPath';
import useCheckRouterValid from 'hook/useCheckRouterValid';
import 'page/Authentication/style/style.scss';
import {
  AuthSidebar,
  BackgroundAuthentication,
  Container,
  TextOnSidebar,
} from 'page/Authentication/styled';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { userInformation } from 'recoil/atom/authentication';

const Authentication = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const { role } = useRecoilValue(userInformation);
  const { checkRouterValid } = useCheckRouterValid();

  useEffect(() => {
    const roles = {
      ROLE_PARTNER_USER: {
        path: `/partner-page`,
      },
      ROLE_PARTNER_ADMIN: {
        path: `/partner-page`,
      },
      ROLE_SOLITON_USER: {
        path: '/my-page',
      },
      ROLE_SOLITON_ADMIN: {
        path: '/manage-company-list',
      },
    };

    if (pathname === '/') {
      const targetPath = checkRouterValid ? roles[role].path : SIGN_IN_PATH;
      navigate(targetPath);
    }
  }, [pathname, role, navigate, checkRouterValid]);

  return (
    <BackgroundAuthentication className="background-authentication">
      <Container className="container">
        <Row className="row">
          <Col xs={0} sm={0} md={0} lg={14} xl={15}>
            <AuthSidebar className="authSidebar">
              <TextOnSidebar className="textOnSidebar">
                <span className="textStyle1">we are</span>
                <br />
                soliton
              </TextOnSidebar>
            </AuthSidebar>
          </Col>
          <Col xs={24} sm={24} md={24} lg={10} xl={9} className="form-scroll">
            <div className="form-container">
              <div className="logo-soliton">
                <Logo />
              </div>
              <Outlet />
            </div>
          </Col>
        </Row>
      </Container>
    </BackgroundAuthentication>
  );
};

export default Authentication;
